import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import { global } from 'choerodon-ui/shared';
import C7NSpin from 'choerodon-ui/lib/spin';
import { DataSetStatus } from '../data-set/enum';
import DataSetComponent from '../data-set/DataSetComponent';
let Spin = class Spin extends DataSetComponent {
    static setDefaultIndicator(indicator) {
        global.DEFAULT_SPIN_INDICATOR = indicator;
    }
    render() {
        const { dataSet, ...otherProps } = this.props;
        const props = {};
        if (dataSet) {
            props.spinning = dataSet.status !== DataSetStatus.ready;
        }
        return React.createElement(C7NSpin, Object.assign({}, otherProps, props));
    }
};
Spin.displayName = 'Spin';
Spin = __decorate([
    observer
], Spin);
export default Spin;
